// 261010 Epic 2 / P5c — khung xem ẢNH đã gửi cho giám khảo (Duyệt B): mở đúng ảnh trong snapshot, đánh dấu vùng nếu BE trả vùng hợp lệ.
// Không có player / thanh thời gian: mốc giây chỉ là chữ "kế hoạch storyboard". Không antd (jest chạy được). `src` đã qua `safeMediaUrl` ở policy.
import React, { useEffect } from 'react';
import type { MediaRegion } from '../../types/filmStepReview';
import { regionStyle } from './reviewMediaPolicy';

export interface ViewerTarget {
  src: string;
  title: string;
  /** Mỗi dòng chữ mô tả (frame · mốc kế hoạch · quan sát). */
  lines: string[];
  region: MediaRegion | null;
}

const ReviewMediaViewer: React.FC<{ target: ViewerTarget; onClose: () => void }> = ({ target, onClose }) => {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [onClose]);
  const box = regionStyle(target.region);
  return (
    <div className="wf-rv-modal" role="dialog" aria-modal="true" aria-label={target.title} data-testid="wf-rv-viewer" onClick={onClose}>
      <div className="wf-rv-modal-in" onClick={(e) => e.stopPropagation()}>
        <div className="wf-rv-modal-h">
          <b>{target.title}</b>
          <button type="button" className="wf-btn ghost" onClick={onClose}>Đóng</button>
        </div>
        <div className="wf-rv-img">
          <img src={target.src} alt={target.title} />
          {box ? <div className="wf-rv-region" data-testid="wf-rv-region" style={box} aria-hidden="true" /> : null}
        </div>
        {target.lines.map((l, i) => <div key={i} className="wf-rv-note">{l}</div>)}
      </div>
    </div>
  );
};

export default ReviewMediaViewer;
